document.addEventListener( 'DOMContentLoaded', () => {
  const closeButtons = document.querySelectorAll( '.b3rg-notification .b3rg-notification__close' );
    
  closeButtons.forEach( ( closeButton ) => {
    closeButton.addEventListener( 'click', ( event ) => {
      // Disable the close button
      event.target.disabled = true;
            
      // Get notification elements
      const notificationId = event.target.getAttribute( 'data-notification-id' );
      const notification = event.target.closest( '.b3rg-notification' );
            
      // Close notification immediately
      notification.classList.add( 'notification-closed' );
            
      // Handle cookie creation in background
      const xhr = new XMLHttpRequest();
      xhr.open( 'POST', b3rgScriptData.ajaxurl, true ); // eslint-disable-line no-undef
      xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
            
      xhr.onload = () => {
        if ( xhr.status < 200 || xhr.status >= 400 ) {
          console.error( xhr.responseText );
          // Revert close if cookie creation fails
          notification.classList.remove( 'notification-closed' );
        }
        event.target.disabled = false;
      };
            
      xhr.onerror = () => {
        console.error( 'Connection error occurred' );
        // Revert close if request fails
        notification.classList.remove( 'notification-closed' );
        event.target.disabled = false;
      };
            
      xhr.send( encodeURI( 'action=b3rg_create_notification_cookie&notification_id=' + notificationId ) );
    } );
  } );
} );
